import { createAction } from "typesafe-actions";
import type { InitialData } from "../../shared/types/state";
import type { WebSourceId } from "../types/common";

export const initWithDataAction = createAction("@@si/account-overview/init-with-data")<InitialData>();

// Page overlay
export const pageOverlayVisibilityChangedAction = createAction(
    "@@si/account-overview/page-overlay-visibility-changed",
)<boolean>();

// Countries selection
export const countriesIdsSelectedAction = createAction(
    "@@si/account-overview/countries-ids-selected",
    (ids: readonly number[], webSourceId?: WebSourceId) => {
        return {
            ids,
            webSourceId,
        };
    },
)();

// Web source selection
export const webSourceIdSelectedAction = createAction("@@si/account-overview/web-source-id-selected")<WebSourceId>();
